export default {
    toolbar: {
        toolbar: 'Início'
    }
}